import {
    createMissionNote,
    updateMissionNote,
    type MissionId,
    type MissionNoteId,
} from '@wwf/sdk';
import { createNestedNotesProvider } from '../factories/createNestedNotesProvider';

export const missionNoteProvider = createNestedNotesProvider({
    parentKey: 'missionId',
    collection: 'missions',
    createNote: (missionId, input) =>
        createMissionNote(missionId as MissionId, input),
    updateNote: (missionId, noteId, input) =>
        updateMissionNote(
            missionId as MissionId,
            noteId as MissionNoteId,
            input
        ),
});
